import FeederDiagrams from '@/resources/feeder-diagrams';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'feederDiagram';
const DEFAULT_STATE = Object.freeze({
  diagram: null
});

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  actions: {
    async createDiagram({ commit }, feederDiagramParams) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const {
        projectCode,
        substationCode,
        externalInstrumentId,
        instrumentType,
        diagramType,
        feederNumber,
        feederDiagramFile
      } = feederDiagramParams;
      try {
        await FeederDiagrams({ projectCode, substationCode }).save({
          external_instrument_id: externalInstrumentId,
          instrument_type: instrumentType,
          diagram_type: diagramType,
          feeder_number: feederNumber,
          feeder_diagram_file: feederDiagramFile
        });
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      } catch (errorResponse) {
        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        return errorResponse.body.errors[0].details;
      }
    },
    async removeDiagram({ commit }, feederDiagramParams) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const {
        projectCode,
        substationCode,
        externalInstrumentId,
        instrumentType,
        diagramType,
        feederNumber,
        diagramId
      } = feederDiagramParams;

      try {
        await FeederDiagrams({ projectCode, substationCode, diagramId }).remove({
          external_instrument_id: externalInstrumentId,
          instrument_type: instrumentType,
          diagram_type: diagramType,
          feeder_number: feederNumber
        });

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      } catch (errorResponse) {
        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        return errorResponse.body.errors[0].details;
      }
    }
  }
};
